import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { extrareducer, exraContentReducer } from "../redux/slice/ExtraSilce";
import { extraLessonReducer } from "../redux/slice/extralessonSlice";
import api from "../utils/api";

const THEMES = {
  active: {
    bg: "bg-yellow-500",
    iconBg: "bg-purple-500",
    title: "text-gray-900",
    divider: "bg-gray-800/20",
    desc: "text-gray-800",
    btn: "bg-purple-600 hover:bg-purple-700 text-white shadow-md active:scale-[0.98]",
    track: "bg-white/30",
    fill: "bg-white",
    progText: "text-white",
  },
  completed: {
    bg: "bg-green-500",
    iconBg: "bg-white/40",
    title: "text-white",
    divider: "bg-white/20",
    desc: "text-green-50",
    btn: "bg-white text-green-600 hover:bg-green-50 shadow-md active:scale-[0.98]",
    track: "bg-green-700/30",
    fill: "bg-white",
    progText: "text-white",
  },
};

function Cart({ lesson }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (!lesson) return null;

  // 1. Progress Hesaplama (Her true = %25)
  const keys = ["true_false", "listen_find", "answer_question", "description"];
  const completedSteps = keys.filter(
    (key) => lesson[key] === true || lesson[key] === "true",
  ).length;
  const progress = completedSteps * 25;

  // 2. Durum Belirleme (Sadece active veya completed var)
  const currentStatus = progress === 100 ? "completed" : "active";
  const t = THEMES[currentStatus];

  // API İsteği
  const fetchExtra = async () => {
    try {
      const response = await api.get("get_extra", {
        params: { name: lesson.name },
      });
      if (response.status === 200) {
        dispatch(extrareducer(response.data.data[0]));
        dispatch(exraContentReducer(lesson._id));
        dispatch(extraLessonReducer(lesson));
        navigate("/extraPage");
      }
    } catch (error) {
      console.error("Veri çekme hatası:", error);
    }
  };

  return (
    <div
      className={`w-full rounded-2xl p-4 flex flex-col gap-3 transition-all duration-300 ${t.bg} shadow-sm`}
      style={{ fontFamily: "Inter, system-ui, -apple-system, sans-serif" }}
    >
      {/* İkon Bölümü */}
      <div className="flex items-center justify-center">
        <div
          className={`w-14 h-14 rounded-full text-2xl flex items-center justify-center ${t.iconBg} backdrop-blur-sm`}
        >
          {lesson.emoji || "📚"}
        </div>
      </div>

      {/* Metin İçeriği */}
      <div className="text-center">
        <p className={`text-base font-bold truncate ${t.title}`}>
          {lesson.title}
        </p>
        <div className={`h-[1px] w-full my-2 ${t.divider}`} />
        <p className={`text-xs leading-tight h-8 overflow-hidden ${t.desc}`}>
          {lesson.descriptionTr || "No description available."}
        </p>
      </div>

      {/* Buton (Her zaman tıklanabilir) */}
      <button
        className={`w-full py-2 px-10 rounded-xl text-sm font-bold transition-all duration-200 ${t.btn}`}
        onClick={fetchExtra}
      >
        {currentStatus === "completed" ? "Repeat" : "Let's Start"}
      </button>

      {/* Progress Bar */}
      <div className="mt-1">
        <div className="flex justify-between items-center mb-1 px-1">
          <span className={`text-[10px] font-bold uppercase ${t.progText}`}>
            İlerleme
          </span>
          <span className={`text-[10px] font-black ${t.progText}`}>
            {progress}%
          </span>
        </div>
        <div className={`w-full h-2 rounded-full overflow-hidden ${t.track}`}>
          <div
            className={`h-full rounded-full transition-all duration-1000 ${t.fill}`}
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
}

export default Cart;
